import { useEffect, useState } from 'react';
import Utils from '../../CourseApp/Helper/utils';
import manager from '../../Manager';

function Header({slides, selectedSlide, saveSlides, lessonTitle, setActionLessonActive}){

    const [saveDisabled, setSaveDisabled] = useState('');

    const handleSaveSlides = () => {
        console.log(slides);
        const slideData = slides.map((item) => {
            return item.toSaveData();
        });
        if (validateSlideBeforeSave(slideData)) {
            saveSlides(slideData);
            setActionLessonActive(false)
            window.jQuery('#tbcourse-modal-active-lesson').modal('show');
            window.jQuery('#tbcourse-modal-active-lesson').modal({
                backdrop: false
            });
            let activatedLesson = window.jQuery('#activatedLesson');
            if (!activatedLesson.prop('checked')) {
                activatedLesson.click();
            }
        }
    }

    const validateSlideBeforeSave = (slideData) => {
        let errCode = 0;
        let errMessage = "";
        const templateData = {
            TextTemplate: ["title", "description"],
            ImageTemplate: ["title", "description", "images"],
            AudioTemplate: ["title", "description", "audio"],
            VideoTemplate: ["title", "description", "platform", "url", "video", "thumbnails", "duration"],
            DocumentTemplate: ["title", "description", "attachment", "downloadable"],
            MultipleChoiceTemplate: ["esay", "answer"]
        };
        slideData.forEach((slide) => {
            const allowed = templateData[slide.type];
            if (allowed) {
                const filtered = Object.keys(slide.data)
                    .filter(key => allowed.includes(key))
                    .reduce((obj, key) => {
                        obj[key] = slide.data[key];
                        return obj;
                    }, {});
                slide.data = filtered;
            }

            if (slide.type === 'VideoTemplate') {
                // if platform=bunnynet from embed, convert duration in minute to seconds for slide.duration
                if (slide.data?.platform === 'bunnynet') {
                    if (slide.data?.duration > 0) {
                        slide.duration = slide.data.duration * 60;
                    } else {
                        slide.duration = manager.getTemplate('VideoTemplate').getDuration();
                    }
                }
            }

            if (slide.type === 'MultipleChoiceTemplate') {
                if (slide.data?.answer === undefined) {
                    errCode++;
                    errMessage = slide.name + ', must have answer';
                }
                if (errCode === 0) {
                    // console.log(slide.data?.answer);
                    let isAnyCorrectAnswer = slide.data?.answer.filter(item => item.correct === true || item.correct === 'true');
                    if (isAnyCorrectAnswer.length === 0) {
                        errCode++;
                        errMessage = slide.name + ', must have correct answer!';
                    }
                }
            }
        });

        if (errCode > 0) {
            console.log(errCode);
        console.log(errMessage);
            Utils.showError(errMessage);
            return false;
        }
        return true;
    }

    useEffect(() => {
        if (selectedSlide) {
            setSaveDisabled(selectedSlide.saveDisabled)
        }
    });

    return (
        <div className='tbcourse-nav'>
            <div className="row align-items-center">
                <div className="col">
                    <h1 className="font-size-22 font-weight-700 mb-0">Your Slide</h1>
                </div>
                <div className="col-auto">
                    <button type="button" className="btn btn-save-lesson font-size-16 font-weight-600 px-3" onClick={handleSaveSlides} disabled={saveDisabled}>Save Changes</button>
                </div>
            </div>
        </div>
    );
}

export default Header;